import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

/**
 * Create a village under a mandal when you only know district key + mandal name + village label (imports).
 */
export async function createVillageByPath(body: {
  districtKey: string;
  mandalName: string;
  villageName: string;
  villageCode?: string;
}): Promise<{ id: number; created: boolean }> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/geo/admin/villages-by-path`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<{ id: number; created: boolean }>;
}
